import { Component, OnInit, Inject, PLATFORM_ID, signal, DestroyRef, inject } from '@angular/core';
import { TrafficsService } from '../../services/traffics.service';
import { OffersResponse } from '../../models/offers/OffersResponse';
import { OffersFilters } from '../../models/filtermodels/OffersFilters';
import { ParamFilters } from '../../models/filtermodels/ParamFilters';
import { AuthGuardService } from '../../services/auth-guard.service';
import { PricedItem } from '../../models/offers/PricedItem';
import { AcvisService } from '../../services/acvis.service';
import { Partner } from '../../models/partner/IPartner';
import { Meta, Title } from '@angular/platform-browser';
import { fromEvent } from 'rxjs';
import { EncryptionService } from '@app/services/encyption.service';
import { Router } from '@angular/router';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { isPlatformBrowser } from '@angular/common';
import { ObjFilter } from '../tools/ObjFilter';
import { MediaService } from '@app/services/media.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-flugs',
    templateUrl: './flugs.component.html',
    styleUrls: ['./flugs.component.scss'],
    standalone: false
})
export class FlugsComponent implements OnInit {
    filtersData: OffersFilters;

    tmp_offers = signal<OffersResponse>(null);
    loading = signal(true);
    loadingmore = signal(false);
    showErsteAngebotButton = signal(false);

    start = signal(1);
    limit = signal(12);

    totalResultCount = signal(0);
    realparams = signal<ParamFilters>(null);
    original_realparams: ParamFilters;
    sortByname = signal('Bester Preis');

    flightCarrierList: PricedItem[];
    tourOperatorList: PricedItem[];
    currentpartner: Partner;

    currentPosition = signal(0);
    exnbr = signal(0);
    isBrowser = signal(false);
    showSmallHeader = signal(false);
    showModal = signal(false);

    destroyRef = inject(DestroyRef);

    constructor(
        protected trafficsService: TrafficsService,
        protected acvisService: AcvisService,
        public hotelService: HotelFiltersService,
        protected mediaService: MediaService,
        protected guardService: AuthGuardService,
        protected router: Router,
        protected encservice: EncryptionService,
        protected metaService: Meta,
        protected titleService: Title,
        @Inject(PLATFORM_ID) protected platformId: any
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            const cleverstyle = document.getElementById('clever-custom-content-style');
            if (cleverstyle) {
                cleverstyle.innerText = '';
            }

            const cleverscript = document.getElementById('clever-custom-content-script');
            if (cleverscript) {
                cleverscript.innerHTML = '';
            }
            this.initExnbr();
            this.initPartnerSub();
        }
        this.setNoIndex();
    }

    async initExnbr() {
        this.hotelService.extrasCount$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(nbr => {
            this.exnbr.set(nbr);
        });
    }

    initPartnerSub(): void {
        this.titleService.setTitle('Offers');
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartner = partner;
                this.initFilters();
            }
        });
    }

    initScrollEvent(): void {
        fromEvent(window, 'scroll').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => this.checkScroll());
    }

    checkScroll(): void {
        const surpos = window.scrollY;
        if (this.currentPosition() > surpos && surpos > 250) {
            this.showSmallHeader.set(true);
        } else {
            this.showSmallHeader.set(false);
        }
        this.currentPosition.set(surpos);
    }

    setNoIndex(): void {
        this.metaService.updateTag({ name: 'robots', content: 'noindex' });
    }

    initFilters(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(params => {
            if (params && JSON.stringify(params) !== JSON.stringify(this.realparams())) {
                this.realparams.set(JSON.parse(JSON.stringify(params)));
                if (!this.original_realparams) {
                    this.original_realparams = JSON.parse(JSON.stringify(params));
                } else {
                    this.showErsteAngebotButton.set(true);
                }
                this.checkFilter();
            }
        });
    }

    backToFirstAngebots() {
        const tmp_original_realparams = JSON.parse(JSON.stringify(this.original_realparams));
        this.original_realparams = null;
        this.showErsteAngebotButton.set(false);
        this.hotelService.setRealParams(tmp_original_realparams);
    }

    reloadData(params) {
        this.showErsteAngebotButton.set(true);
        this.realparams.set(JSON.parse(JSON.stringify(params)));
        this.checkFilter();
    }

    checkFilter(): void {
        // this.gotoAngebote();
        this.tmp_offers.set(null);
        if (!(this.realparams()?.arrivalAirportList?.length > 0)) {
            this.hotelService.gototopregions();
        } else {
            this.start.set(0);
            this.limit.set(12);

            this.filtersData = {} as OffersFilters;
            const myobj = new ObjFilter(this.realparams(), this.limit(), this.currentpartner.agenturen);
            this.filtersData = myobj.initFilters();
            this.getOffers();
        }
    }

    async gotoAngebote() {
        const invalidElements = document.getElementById('smoothid');
        if (invalidElements) {
            invalidElements.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    initNavigate(): void {
        this.filtersData.navigation = this.start + ',' + this.limit;
    }

    getOffers(): void {
        // filter.setinstat = true;
        this.loading.set(true);
        const productType = String(this.realparams()?.productType || 'flight').toLowerCase();
        const endpoint = productType === 'oneway' ? 'offers/oneway' : 'offers/flight';
        const requestFilter = { ...this.filtersData };
        delete requestFilter.productType;
        this.trafficsService.request(requestFilter, endpoint).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
            if (!this.tmp_offers()) {
                this.tmp_offers.set(res);
            } else {
                this.tmp_offers().offerList = [
                    ...(this.tmp_offers().offerList || []),
                    ...(res?.offerList || res?.offers || []),
                ];
            }
            this.loading.set(false);
            this.loadingmore.set(false);
            this.totalResultCount.set(Number(res?.totalResultCount || res?.pagination?.anzahl_angebote || 0));

        })
        // this.offersObservable = this.loadingmoreort.pipe(
        //     mergeMap(_ => this.trafficsService.request(this.filtersData, 'ibeoffers').pipe(
        //         finalize(() => {
        //             this.loading.set(false);
        //             this.loadingmore.set(false);
        //             this.cdr.detectChanges();
        //         }),
        //         tap((res: OffersResponse) => {
        //             this.totalResultCount = Number(res.totalResultCount);
        //         }),
        //     )),
        //     scan<OffersResponse>((all: OffersResponse, current: OffersResponse) => {
        //         current.offerList = [...all.offerList, ...current.offerList];
        //         return current;
        //     })
        // );
    }

    async loadingMoreManualy() {
        if (this.start() + this.limit() < this.totalResultCount()) {
            this.loadingmore.set(true);
            this.start.set(this.start() + this.limit() > this.totalResultCount() ? this.totalResultCount() : this.start() + this.limit());
            this.filtersData.navigation = this.start + ',' + this.limit;
            this.loadingmore.set(true);
            this.getOffers();
        }
    }

    async initSortbyName() {
        switch (this.realparams().sortBy) {
            case 'fromDate':
                this.sortByname.set('Datum');
                break;
            default:
                this.sortByname.set('Bester Preis');
                break;
        }
        this.sortByname;
    }

    async sortby(value, name) {
        this.start.set(0);
        this.limit.set(12);
        // this.gotoAngebote();
        this.initNavigate();
        this.filtersData.sortBy = value;
        this.sortByname.set(name);
        this.getOffers();
    }

    openModalMobile() {
        this.showModal.set(true);
    }

    closeModalMobile() {
        this.showModal.set(false);
    }

    take() {
        this.showModal.set(false);
    }

    trackByFn(index, item) {
        return index; // or item.id
    }
}
